import { z } from 'zod';
import { permissionSchema } from '../permissions.js';
import { EMAIL_MAX_LENGTH, NAME_MAX_LENGTH, SIGNUP_FORM_MESSAGES } from './signup-form.js';
/**
 * The Add user and Edit permissions dialogs' rules and messages, written once
 * here so the dashboard shows the same text whether it checks before sending
 * or the API refuses the request (`patterns/error-handling.md`, 3). The copy is
 * the users-and-permissions feature's `ux.md`, States; the limits are sign-up's
 * (users-and-permissions `technical.md`, `POST /api/dashboard/account/users`).
 *
 * Spaces around the email address and the name are ignored, and a name of only
 * spaces counts as no name.
 */
export const ADD_ACCOUNT_USER_FORM_MESSAGES = {
    emailRequired: 'Enter an email address.',
    emailFormat: 'Enter a valid email address, like name@example.com.',
    emailTooLong: SIGNUP_FORM_MESSAGES.emailTooLong,
    nameTooLong: SIGNUP_FORM_MESSAGES.nameTooLong,
    /**
     * Whatever state the existing login is in: verified, unverified or a removed
     * Account User's. It never says which, or whose (`ux.md`, Add user dialog).
     */
    emailInUse: "This email address can't be added because it already has a login in Groundly. Use a different email address.",
};
/** Piped, so an empty field reports only that it is empty. */
const emailSchema = z
    .string()
    .transform((value) => value.trim())
    .pipe(z.string().min(1, { error: ADD_ACCOUNT_USER_FORM_MESSAGES.emailRequired }))
    .pipe(z.string().max(EMAIL_MAX_LENGTH, { error: ADD_ACCOUNT_USER_FORM_MESSAGES.emailTooLong }))
    .pipe(z.email({ error: ADD_ACCOUNT_USER_FORM_MESSAGES.emailFormat }));
/** Optional: empty means no name, and the email address is shown instead. */
const nameSchema = z
    .string()
    .transform((value) => value.trim())
    .pipe(z.string().max(NAME_MAX_LENGTH, { error: ADD_ACCOUNT_USER_FORM_MESSAGES.nameTooLong }));
/** Any combination of permissions, each once. */
const permissionListSchema = z
    .array(permissionSchema)
    .transform((permissions) => [...new Set(permissions)]);
/**
 * The complete permission set for an Account User. `isSuperUser` gives every
 * permission, including ones added later, and `permissions` is then ignored; a
 * set that holds every permission makes a super user too
 * (`patterns/auth-patterns.md`, 3).
 */
export const accountUserPermissionsSchema = z.object({
    permissions: permissionListSchema,
    isSuperUser: z.boolean(),
});
export const addAccountUserSchema = accountUserPermissionsSchema.extend({
    email: emailSchema,
    name: nameSchema,
});
//# sourceMappingURL=add-account-user-form.js.map